import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=0c096a02&scoped=true"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=0c096a02&prod&scoped=true&lang=css"
import style1 from "./ClientList.vue?vue&type=style&index=1&id=0c096a02&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c096a02",
  null
  
)

export default component.exports